import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import * as fromAdmin from '@app/client/account/admin/reducers';
import { TeamsActions } from '@app/client/account/admin/teams/actions';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminTeamsLoadedGuard  {

  constructor(
    private store$: Store<fromAdmin.State>,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true);
    }

    this.store$.dispatch(TeamsActions.loadAccountTeams());
    return this.store$.select(fromAdmin.getAccountTeamsLoaded).pipe(
      first(loaded => !!loaded)
    );
  }
}
